import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { CompanyService } from './../../../../core/services/company/company.service';
import { ChangeDetectorRef, Component, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  emailExist,
  emailcontactExist,
  fileTypeExtention,
  linkedincontactExist,
  maxSizeFile,
  nameExist,
  serverError,
  successEditProfileadmin,
} from './../../../../core/models/messages';
import {
  linkedCompanyRegExp,
  linkedInRegExp,
  patternEmail,
  patternWebsite,
} from './../../../../core/models/pattern';
import { ICountry, IState, State } from 'country-state-city';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  CountryISO,
  PhoneNumberFormat,
  SearchCountryField,
} from 'ngx-intl-tel-input';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { translations } from '../../../../core/models/call-offer';
import { PaysserviceService } from '@core/services/pays/paysservice.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-profil-esn',
  templateUrl: './profil-esn.component.html',
  styleUrls: ['./profil-esn.component.css'],
})
export class ProfilEsnComponent {
  @ViewChild('phoneInput') phoneInput: any;
  PhoneNumberFormat = PhoneNumberFormat;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  currentUser: any;
  id: any;
  profil_id: any;
  profil_image: any;
  last_name: any;
  first_name: any;
  contactphone: any;
  selectedUser: any;
  ContactEmail: any;
  city: any;
  country: any;
  linkedin_link: any;
  website_link: any;
  phone: any;
  name: any;
  fileError: string = '';
  disabledMode: boolean = true;
  roleuser: any;
  logo: any;
  fileExtention: string = '';
  reviewCompany: any;
  reviewCandidat: any;
  RoleUserId: string = '';
  roles = [
    { id: 1, name: 'Admin' },
    { id: 2, name: 'Super admin' },
  ];
  type = [
    { id: '2', nametype: 'ESN' },
    { id: '3', nametype: 'CLIENT FINAL' },
    { id: '4', nametype: 'CABINET DE RECRUTEMENT' },
  ];
  size = [
    { id: '1', value: '0 à 2' },
    { id: '2', value: '3 à 10' },
    { id: '3', value: '11 à 50' },
    { id: '4', value: '201 à 500' },
    { id: '5', value: '501 à 1000' },
    { id: '6', value: '1001 à 5000' },
    { id: '7', value: '5001 à 10000' },
    { id: '8', value: '10000 et plus' },
  ];
  file: any;
  /* unsubscription */
  validPhoneNumber: boolean = false;
  private unsubscribeAll: Subject<void> = new Subject();
  typeintervenant: string | null | number =
    this.localStorageService.getData('typeintervenant');
  entreprise: any
  roleintervenant: any
  separateDialCode: boolean = false;
  selectedImage: any;
  fileName: string = '';
  user: any;
  url: string = environment.baseUrl + '/api';
  formData = new FormData();
  isImageChanged: boolean = false;
  selectedCountryCode: string = 'FR';
  modalRef?: BsModalRef;
  phoneForm: FormGroup = this.createFormPhone();
  userForm: FormGroup = this.createUserForm();
  userForminter: FormGroup = this.createUserForminter();
  private profileUpdatedSubject = new BehaviorSubject<boolean>(false);
  profileUpdated$ = this.profileUpdatedSubject.asObservable();
  stateList!: IState[];
  paysList: ICountry[] = [];
  idinter: any;
  firstnameinter: any;
  lastnameinter: any;
  currentUserinter: any;
  dataEsn: any;
  image_url: any;
  countryKey: any;
  currentDate!: string;
  minDate!: string;
  today=new Date();
  showComponent:boolean =true;
  imageurl:any;
  listCandidatReviewDetails:any
  isFormModified(): boolean {
    return this.userForm.dirty;
  }
  constructor(
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private companyService: CompanyService,
    private toastrService: ToastrService,
    private modalService: BsModalService,
    private localStorageService: LocalStorageService
    , private cdr: ChangeDetectorRef,
     private router: Router,
    private paysServices: PaysserviceService
  ) { 
    const day = String(this.today.getDate()).padStart(2, "0");
    const month = String(this.today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = this.today.getFullYear();
    this.currentDate = `${year}-${month}-${day}`;
     // Set the minimum date to 10 years ago, for example
     const minYear = 1990;
     this.minDate = `${minYear}-${month}-${day}`;
  }
  ngOnInit() {
    this.paysList = this.paysServices.getAllCountries();
    const connectedUser = JSON.parse(this.localStorageService.getData('UserInfo') || '{}')
   
    this.id = connectedUser?.company?.uuid
    this.idinter = connectedUser?.uuid;
    this.typeintervenant = this.localStorageService.getData('typeintervenant');
    window.scrollTo(0, 0);
    this.getuserById();
    this.getuserByIdintervenant()
    this.userForm.valueChanges.subscribe(() => {
      this.isFormModified();
    });
    this.getReviewCompany();
    this.getReviewCandidat();
    this.onPhoneChange();
    this.getUserId();
  }
  esnDetails: any;
  createUserForm(data?: any) {    
    return this.formBuilder.group({
      name: [data ? data.name : '', [Validators.required]],
      ContactEmail: [
        data ? data.ContactEmail : '',
        [Validators.email,
        Validators.pattern(patternEmail),
        ],
      ],
      ContactPhone: [data ? data.ContactPhone : ''],
      logo: [ data ? `${this.url}/Company/file/gallery_company/${data.logo }`: `${this.url}/Company/file/gallery_company/${this.logo}` ],
      about:[data ? data.about : ''],
      address:[data ? data.address : ''],
      siret:[data ? data.siret : ''], 
      year_of_creation:[data?.year_of_creation ? new Date(data.year_of_creation).getFullYear().toString() : ''],
      size_company:[data ? data.size_company : ''],
      linkedin_link: [
        data ? data.linkedin_link : '',
        [Validators.pattern(linkedCompanyRegExp)],
      ],
      website_link: [
        data ? data.website_link : '',
        [Validators.pattern(patternWebsite)],
      ],
      country: [data ? data.country : ''],
      city: [data ? data.city : ''],
      role_user_id: [data ? data.role_user_id : ''],
      domain: [data ? data.domain : null],
      type: [data ? data.type : '', [Validators.required]],
      admin_first_name: [data ? data.user?.first_name:'',[Validators.required]],
      admin_last_name: [data ? data.user?.last_name:'',[Validators.required]],
      admin_phone: [{value: data ?data.user?.phone_number:''} ]
    });

  }
  translateCountryName(name: string): string {

    return translations[name] || name;
  }
  getUserId() {
    this.spinner.show();
    this.companyService
      .getUserByIdsidebare(this.idinter)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          console.log('testtt res.dvvvvata',res.data.role_user_id)
          this.RoleUserId=res.data.role_user_id[0]
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  navigatToDetailsCandidat(id: any) {   
    this.router.navigate([
      '/candidats/profilecandidatesn',id]);
  }
  getuserById() {
   
      this.spinner.show();
      this.companyService
        .getCompanydetail(this.id)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            console.log('testtt res.data',res?.data)
            if(res?.data?.length > 0 ){

            this.currentUser = res.data[0];
            this.name = res.data[0].name;
            this.ContactEmail = res.data[0].ContactEmail;
            this.phone = res.data[0].ContactPhone;
            this.city = res.data[0].city;
            this.linkedin_link = res.data[0].linkedin_link;
            this.website_link = res.data[0].website_link;
            this.roleuser = res.data[0].user.role_user_id[0];
           this.logo =`${this.url}/Company/file/gallery_company/${res.data[0].logo}`;
            this.dataEsn=res.data[0];
            
            this.userForm = this.createCompanyDetailsForm(res.data[0]);
            this.countryKey = this.getKeyFromValue( res.data[0].country);
            const selectedCountry = this.paysList.find(
              (country) => country.name === this.countryKey
            );
  
            if (selectedCountry) {
              this.stateList = State.getStatesOfCountry(selectedCountry.isoCode);
             
            }
            this.userForm
              .get('country')
              ?.setValue(
                res.data[0]?.country === 'null' || res.data[0]?.country == null ? '' : res.data[0].country
              );
            this.userForm
              .get('city')
              ?.setValue(res.data[0]?.city === 'null' || res.data[0]?.city == null  ? '' : res.data[0].city);
            this.phoneForm
              .get('phone')
              ?.setValue(this.userForm.get('phone_number')?.value);
            }
            this.spinner.hide();
          },
          error: () => {
            this.spinner.hide();
          },
        });
    // }
  }
  getKeyFromValue(value: any) {
    const entries = Object.entries(translations);
    const foundEntry = entries.find(([key, val]) => val === value);
    return foundEntry ? foundEntry[0] : undefined;
  }


  getuserByIdintervenant() {

    this.spinner.show();
    this.companyService
      .getUserById(this.idinter)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {          
          this.firstnameinter = res.data?.first_name;
          this.lastnameinter = res.data?.last_name;

          this.entreprise = res.data?.company_name

          this.roleintervenant = res.data?.employee_role_name;
          console.log('this.roleintervenant',res.data)
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  getImageSource(): string {
    const imageUrl = this.userForm.get('logo')?.value;
    return imageUrl
      ? `${this.url}/Company/file/gallery_company/${imageUrl}`
      : '';
  }
  onInputChange(data: any) {
    const ContactPhone = data.ContactPhone;
    this.validPhoneNumber = data.isNumberValid;
    this.userForm.get('ContactPhone')?.setValue(ContactPhone);
  }
  handleKeyPress(event: any) {
    const allowedCharacters = /^[0-9+]+$/;

    if (!allowedCharacters.test(event.key)) {
      event.preventDefault();
    }
  }
  clearImage() {
    this.fileName = '';
    this.selectedImage = null;
    this.fileExtention = ''
    this.file = null;
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      // fileInput.value = ''; // Clear the file input value
      this.logo = 'avatar.png'
    }
    this.userForm.get('logo')?.setValue('avatar.png');

    this.isImageChanged = false;
  }
  onCountryChangetel(): void {
    this.phoneForm.get('phone')?.reset();
    this.cdr.detectChanges();
  }
  onPhoneChange(): void {
    this.phoneForm.get('phone')?.valueChanges.subscribe((newValue) => {
    });
  }
  onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
      this.userForm.get('city')?.reset();
    } else {
      this.stateList = [];
      this.userForm.get('city')?.setValue('');
      this.userForm.get('city')?.reset();
    }
  }

  createFormPhone(data?: any) {
    return this.formBuilder.group({
      phone: [data && data.phone],
    });
  }

  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    // Retirer tout caractère qui n'est pas un chiffre, un slash ou un espace
    input.value = input.value.replace(/[^0-9\/]/g, '');
  }

  openModal(template: TemplateRef<any>, data?: any) {
    this.modalRef = this.modalService.show(template);
    if (data) {
        this.userForm = this.createUserForm(data);
        this.logo= `${this.url}/Company/file/gallery_company/${data.logo}`
        this.userForm.get('name')?.setValue( data.name === 'null' || data.name == null ? '' : data.name);
        this.userForm.get('ContactEmail')?.setValue( data.ContactEmail === 'null' || data.ContactEmail == null ? '' : data.ContactEmail);
        this.userForm.get('website_link')?.setValue(
            data.website_link === 'null' || data.website_link == null ? '' : data.website_link
        );
        this.userForm.get('linkedin_link')?.setValue(
          data.linkedin_link === 'null' || data.linkedin_link == null ? '' : data.linkedin_link
      );
      this.userForm.get('type')?.setValue(
        data.type === 'null' || data.type == null ? '' : data.type
      );

      this.userForm.get('about')?.setValue(
            data.about === 'null' || data.about == null ? '' : data.about
      );
      this.userForm.get('address')?.setValue(
        data.address === 'null' || data.address == null ? '' : data.address
    );

    this.userForm.get('size_company')?.setValue(
     data.size_company === 'null' || data.size_company == null ? '' : data.size_company
    ); 
    this.userForm.patchValue({
      size_company: data.size_company ? data.size_company : null
    });
     this.userForm.get('admin_first_name')?.setValue(
      data.user?.first_name === 'null' || data.user?.first_name == null ? '' : data.user?.first_name
     );

     this.userForm.get('admin_last_name')?.setValue(
      data.user?.last_name === 'null' || data.user?.last_name == null ? '' : data.user?.last_name
    );

    this.userForm.get('admin_phone')?.setValue(
      data.user?.phone_number === 'null' || data.user?.phone_number == null ? '' : data.user?.phone_number
    );

    this.userForm.get('domain')?.setValue(
    data.domain === 'null' || data.domain == null ? '' : data.domain
    );    
    this.userForm.get('year_of_creation')?.setValue(
      data.year_of_creation === 'null' || !data.year_of_creation ? '' : data.year_of_creation
  );

    this.userForm.get('siret')?.setValue(
      data.siret === 'null' || data.siret == null ? '' : data.siret
  );

        this.userForm.get('city')?.setValue(
            data.city === 'null' || data.city == null ? '' : data.city
        );

        this.userForm.get('country')?.setValue(
            data.country === 'null' || data.country == null ? '' : data.country
        );
        this.userForm.patchValue({
          country: data.country ? data.country : null
        });
         this.userForm.get('logo')?.setValue((data.logo === 'null' || data.logo == null) ? `${this.url}/Company/file/gallery_company/avatar.png` : `${this.url}/Company/file/gallery_company/${data.logo}`);

        this.userForm.get('ContactPhone')?.setValue(
            data.ContactPhone === 'null' || data.ContactPhone == null ? '' : data.ContactPhone
        );
        this.phoneForm.get('phone')?.setValue(
            this.userForm.value.ContactPhone === 'null' || this.userForm.value.ContactPhone == null ? '' : this.userForm.value.ContactPhone
        );

        if (this.file) {
            this.formData.append('logo', this.file);
        }
    }
}

  closeModal() {
    this.stateList=[];
    this.modalRef?.hide();
    // this.userForm.reset();
    this.formData = new FormData();
    this.file = null;
    this.fileError = '';
    this.fileName = '';
    this.fileExtention = '';
  }


  async onSubmit() {
    const imageUrl = this.userForm.get('logo')?.value;
    this.showComponent = false;
    this.spinner.show();
    this.setValidatorRequirements()
    const phone = this.phoneForm.get('phone')?.value;
    const internationalPhoneNumber = phone?.internationalNumber || '';

    // this.userForm.get('ContactPhone')?.setValue(internationalPhoneNumber);
    // this.formData.append('ContactPhone', internationalPhoneNumber);
    if (internationalPhoneNumber) {
      this.userForm.get('ContactPhone')?.setValue(internationalPhoneNumber);
      this.formData.append('ContactPhone', internationalPhoneNumber);
    } else {
      this.formData.delete('ContactPhone');
      this.userForm.get('ContactPhone')?.setValue('');
    }

    this.formData.append('name', this.userForm.get('name')?.value);

    const linkedinLink = this.userForm.value.linkedin_link;
    if (this.userForm.value.linkedin_link === null || !this.userForm.value.linkedin_link) {
      this.formData.delete('linkedin_link');
    } else {
      this.formData.append('linkedin_link', linkedinLink);
    }

    const website_link = this.userForm.value.website_link;
    if (this.userForm.value.website_link===null || !this.userForm.value.website_link) {
      this.formData.delete('website_link'); 
    } else {
      this.formData.append('website_link', website_link);
    }
    
    if(this.userForm.value.city===null){
      this.userForm.get('city')?.setValue('');
    }
    else {
      this.formData.append('city', this.userForm.get('city')?.value);
    }
    
    this.formData.append('about', this.userForm.get('about')?.value);


    if(this.userForm.value.country===null){
          this.formData.delete('country'); 
    }
    else {
      this.formData.append('country', this.userForm.get('country')?.value);
    }
    

    if (!this.file && imageUrl) {
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const fileName = imageUrl.split('/').pop() || 'image.jpg';
        this.file = new File([blob], fileName, { type: blob.type });
        this.formData.append('logo', this.file);
      } catch (error) {
        this.formData.append('logo', imageUrl);
      }
    } else if (this.file) {
      this.formData.append('logo', this.file);
    }

    this.formData.append(
      'ContactEmail',
      this.userForm.get('ContactEmail')?.value
    );

    this.formData.append(
      'address',
      this.userForm.get('address')?.value
    );

    this.formData.append(
      'siret',
      this.userForm.get('siret')?.value
    );

    let date = this.userForm.get('year_of_creation')?.value;
    if (date) {
      date = new Date(date).getFullYear();
    } else {
      date = '';
    }
    
    this.formData.append('year_of_creation', date);
    if(this.userForm.value.size_company===null){
      this.formData.delete('size_company'); 
    }
    else {
      this.formData.append('size_company', this.userForm.get('size_company')?.value);
    }
   
    this.formData.append(
      'domain',
      this.userForm.get('domain')?.value
    );  
    this.formData.append(
      'admin_last_name',
      this.userForm.get('admin_last_name')?.value
    );  
    this.formData.append(
      'admin_first_name',
      this.userForm.get('admin_first_name')?.value
    );  
    
    const adminPhone = this.userForm.get('admin_phone')?.value?.internationalNumber || null;
    if(adminPhone  && adminPhone !== "null"){
      this.formData.append('admin_phone', adminPhone); 

    }
   if(this.logo==`${this.url}/Company/file/gallery_company/avatar.png`){
    this.userForm.get('logo')?.setValue(this.file);

  } 
    this.companyService
      .updateCompany(this.formData)
      .pipe()
      .subscribe({
        next: (res) => {
     
          this.formData = new FormData();
          if (res.status == 200) {
            this.toastrService.success(successEditProfileadmin);
            this.fileName = '';

            this.closeModal();
            this.getuserById();
            this.profileUpdatedSubject.next(true);
            this.companyService.setAccount(this.formData);
           this.showComponent = true
            this.spinner.hide();
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.formData = new FormData();
          if (err?.error) {
            if (err.error?.message['email']) {
              this.toastrService.error(emailExist);
            }
            if (
              err.error?.data.name === 'The name has already been taken.'
            ) {
              this.toastrService.error(nameExist);
              // this.closeModal();
            }
            if (err?.error && err?.error?.data && err?.error?.data?.ContactEmail && (err?.error?.data?.ContactEmail[0] === 'The ContactEmail has already been taken.' || err?.error?.data?.ContactEmail[0] === 'The contact email has already been taken.')) {
              this.toastrService.error(emailcontactExist);
              // this.closeModal();
            }
            if (err?.error?.data?.linkedin_link &&
              err?.error?.data?.linkedin_link[0] === 'The linkedin_link has already been taken.'
            ) {
              this.toastrService.error(linkedincontactExist);
              // this.closeModal();
            }
            if (err?.error?.data?.website_link &&
              err?.error?.data?.website_link[0] === 'The website link has already been taken.'
            ) {
              this.toastrService.error('Site web existe déjà');
              // this.closeModal();
            }
            if (err?.error?.data?.ContactPhone &&
              err?.error?.data?.ContactPhone[0] === 'The ContactPhone has already been taken.'
            ) {
              this.toastrService.error('Numéro de téléphone existe déjà');
              // this.closeModal();
            }
            if (err?.error?.data?.name &&
              err?.error?.data?.name[0] === 'The name has already been taken .'
            ) {
              this.toastrService.error(nameExist);
              // this.closeModal();
            }
          }
        },
      });
  }

  openModalDetails(template: TemplateRef<any>,idDonneur:any) {
    this.modalRef = this.modalService.show(template,{backdrop: 'static'});
    console.log("idDonneur",idDonneur)
    this.getCandidatReviewDetails(idDonneur)
  }
  closeModalDetails() {
    this.modalRef!.hide();
  }
  getCandidatReviewDetails(idDonneur?:any) {
    this.spinner.show()
    this.companyService.getCandidatReviewById(idDonneur, this.id ).pipe(takeUntil(this.unsubscribeAll)).subscribe({
      next: (res) => {
        if (res.status == 200) {
         
          this.listCandidatReviewDetails = res
          this.spinner.hide()
        }
      },
      error: () => {
        this.spinner.hide()
    
      }
    })
  }
  setValidatorRequirements() {
    if (
      !this.userForm.get('linkedin_link')?.value ||
      this.userForm.get('linkedin_link')?.value == ''
    ) {
      this.userForm
        .get('website_link')
        ?.setValidators([Validators.required, Validators.pattern(patternWebsite)]);
      this.userForm.get('website_link')!.updateValueAndValidity();
      this.userForm.get('linkedin_link')?.clearValidators();
      this.userForm.get('linkedin_link')?.updateValueAndValidity();
    }
    if (this.userForm.get('website_link')?.value == '') {
      this.userForm
        .get('linkedin_link')
        ?.setValidators([
          Validators.required,
          Validators.pattern(linkedCompanyRegExp),
        ]);
      this.userForm.get('linkedin_link')!.updateValueAndValidity();
      this.userForm.get('website_link')?.clearValidators();
      this.userForm
        .get('website_link')
        ?.setValidators(Validators.pattern(patternWebsite));
      this.userForm.get('website_link')?.updateValueAndValidity();
    }
    if (   !this.userForm.get('admin_last_name')?.value || this.userForm.get('admin_last_name')?.value == '') {
      this.userForm.get('admin_last_name')?.setValidators([Validators.required]);
    }

  }
  createUserForminter(data?: any) {
    return this.formBuilder.group({
      first_name: [data && data.first_name],
      last_name: [data && data.last_name],
      email: [data && data.email, [Validators.pattern(patternEmail)]],
      emailPro: [data && data.email, [Validators.pattern(patternEmail)]],
      linkedin_link: [
        data && data.linkedin_link ? data.linkedin_link : '',
        [Validators.pattern(linkedInRegExp)],
      ],
      phone_number: [data && data.phone_number ? data.phone_number : ''],
      cv: [data && data.cv ? data.cv : ''],
      image_url: [data && data.image_url ? data.image_url : ''],
      user_id: [data ? data.user_id : ''],
      address: [data ? data.address : ''],
      siret: [data ? data.siret : ''],
      domain: [data ? data.domain : '']

    });
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
    async uploadFile(event: any) {
      const file = event.target.files[0];
      const maxSize = 2 * 1024 * 1024; // 2MB
      const allowedExtensions = ['.jpeg', '.jpg', '.png', '.gif', '.jfif', '.avif'];
      
      if (file) {
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        this.isImageChanged = true;
        
        if (!allowedExtensions.includes(fileExtension)) {
          this.fileExtention = fileTypeExtention;
          this.fileName = '';
          this.toastrService.error("Le format du fichier n'est pas accepté.Veuillez choisir une photo");
          return;
        } 
        
        if (file.size > maxSize) {
          this.fileError = maxSizeFile;
          this.fileName = '';
          this.toastrService.error(maxSizeFile);
          return;
        }
        
        // If validation passes
        this.file = file;
        this.fileName = file.name;
        this.fileError = '';
        this.fileExtention = '';
        
        // Create preview
        const reader = new FileReader();
        reader.onload = () => {
          this.selectedImage = reader.result;
          this.userForm.patchValue({
            logo: this.file
          });
        };
        reader.readAsDataURL(file);
      }
    }
  /* create add company details form */
  createCompanyDetailsForm(data?: any) {
    return this.formBuilder.group({
      id: [data ? data.id : null, [Validators.required]],
      name: [data ? data.name : '', [Validators.required]],
      type: [data ? data.type : null, [Validators.required]],
      domain: [data ? data.domain : '', [Validators.required]],
      number_of_salaries: [
        data ? data.number_of_salaries : '',
        [Validators.required],
      ],
      note: [data ? data.note : null, [Validators.required]],
      // created_at: [data ? data.created_at : null, [Validators.required]],
      //  employee:[data ? data.employee[0].user.first_name : ""],
      //  employeeprenom:[data ? data.employee[0].user.last_name : ""],
      email: [data ? data.user?.email : '', [Validators.required]],
      logo: [data ? `${this.url}/Company/file/gallery_company/${data.logo }` : `${this.url}/Company/file/gallery_company/avatar.png`],
      linkedin_link: [data ? data.linkedin_link : '', [Validators.required]],
      website_link: [data ? data.website_link : '', [Validators.required]],
      phone_number: [
        data ? data.user?.phone_number : '',
        [Validators.required],
      ],
      adresse: [data ? data.city : null, [Validators.required]],
      addre: [data ? data.country : null, [Validators.required]],

    });
  }
  getReviewCompany() {
    this.spinner.show();
    this.companyService
      .getReviewCompany(this.id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.reviewCompany = res;
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  /*get  candidat */
  getReviewCandidat() {
    this.spinner.show();
    this.companyService
      .getReviewCandidat(this.id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.reviewCandidat = res.data.data;
          console.log('this.reviewCandidat',this.reviewCandidat)
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  //@TOFIX: duplicated
  /**
   * Redirects to a specified URL. Opens the URL in a new tab if `isBlank` is `true`.
   * 
   * @param url - The URL to redirect to.
   * @param isBlank - If `true`, opens the URL in a new tab; otherwise, navigates in the same tab.
   */
  // redirectTo(url: string, isBlank: boolean): void {
  //   if (!url) {
  //     return;
  //   }
  //   if (isBlank) {
  //     window.open(url, '_blank');
  //   } else {
  //     window.location.href = url;
  //   }
  // }

  redirectTo(url: string | undefined, newTab = false): void {
    if (!url) return;
    let fullUrl = url.trim();
    if (!/^https?:\/\//i.test(fullUrl)) {
      fullUrl = 'https://' + fullUrl;
    }
    if (newTab) {
      window.open(fullUrl, '_blank');
    } else {
      window.location.href = fullUrl;
    }
  }

}
